import { useCalendarEvents } from '../../hooks/useCalendarEvents';
import { CalendarView } from '../_CalendarView';
import { CalendarSidebar } from '../CalendarSidebar';
import { CalendarToolbar } from '../CalendarToolbar';

export function CalendarLayout() {
  const { events, moduleStates, refetch } = useCalendarEvents();

  return (
    <div className="@CalendarLayout flex h-full">
      <div className="w-64 shrink-0">
        <CalendarSidebar
          moduleStates={moduleStates}
          onRetry={(module) => refetch(module)}
        />
      </div>

      <div className="flex flex-1 flex-col overflow-hidden">
        <div className="shrink-0 border-b border-neutral/10">
          <CalendarToolbar />
        </div>

        <div className="flex-1 overflow-hidden">
          <CalendarView events={events} />
        </div>
      </div>
    </div>
  );
}
